import { de_DeleteSimulationCommand, se_DeleteSimulationCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
export { $Command };
export class DeleteSimulationCommand extends $Command.classBuilder()
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
    ];
})
    .s("SimulationService", "DeleteSimulation", {})
    .n("SimulationServiceClient", "DeleteSimulationCommand")
    .f(void 0, void 0)
    .ser(se_DeleteSimulationCommand)
    .de(de_DeleteSimulationCommand)
    .build() {
}
